









import { Vue, Component } from "vue-property-decorator";
import * as SnackStore from "../store/modules/snack";

@Component({})
export default class Snack extends Vue {
  // Props
  // Data
  // Computed
  get text() {
    return SnackStore.getters.text;
  }

  get type() {
    return SnackStore.getters.type;
  }

  get timeout() {
    return SnackStore.getters.timeout;
  }

  get show() {
    return SnackStore.getters.show;
  }
  set show(val) {
    if (!val) {
      SnackStore.mutations.hideSnack();
    }
  }
  // Methods
  // Life-cycle hooks
}
